/**
 * Download JSON data as a file
 * @param filename - Name of the file to download
 * @param data - Data to serialize as JSON
 */
export function downloadJson(filename: string, data: unknown): void {
  try {
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.style.display = 'none';
    
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    
    // Clean up the object URL
    setTimeout(() => URL.revokeObjectURL(url), 100);
  } catch (error) {
    console.error('Failed to download JSON:', error);
    throw new Error('Failed to download debug bundle');
  }
}

/**
 * Generate a timestamped filename for debug bundle
 * @param prefix - Filename prefix (default: 'atlas-system-rec-debug-bundle')
 * @returns Formatted filename with timestamp
 */
export function generateDebugBundleFilename(prefix = 'atlas-system-rec-debug-bundle'): string {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const min = String(now.getMinutes()).padStart(2, '0');
  
  return `${prefix}-${yyyy}${mm}${dd}-${hh}${min}.json`;
}
